import React from "react";

import "./paymentSuccessful.m.css";

const PaymentSuccessful = () => {
  return (
    <div styleName="wrapper">
      <div styleName="header-wrapper">
        <span styleName="header-title">Payment Successful</span>
      </div>

      <div styleName="content">
        <span styleName="congratulations-msg">Congratulations!</span>
        <span styleName="title1">You are now a Quint Member.</span>
        <span styleName="title2">Thank you for supporting independent journalism.</span>
        <span styleName="title3">We’ll email you shortly with other details.</span>
        <a
          styleName="join-members-group"
          href="https://www.facebook.com/groups/2596502677070141/"
          target="_blank"
          rel="nofollow"
        >
          Join Our Exclusive Member’s Group
        </a>
      </div>
    </div>
  );
};

export default PaymentSuccessful;
